<template>
  <div style="margin-top: 40%">
    <h3>{{ title }}</h3>
    <component :is="is" :loading="loading" @next="next1" @confirm="confirm"></component>
    <z-modal width="434px" :visible.sync="visible" title="发送验证码" :button="false">
      <div class="retrieve_modal">
        <p style="color: #5E668D; font-size: 16px;margin-bottom: 16px;">
          验证码已发送至你的注册手机
        </p>
        <div class="verify_box">
          <a-input class="base_style mb_24" :disabled="true" :value="handlePhone(params.telphone)"></a-input>
          <span class="edit_btn" @click="visible = false">修改</span>
        </div>
        <div class="verify_box">
          <a-input v-model="params.code" class="base_style mb_24" :maxLength="6" placeholder="请输入验证码"></a-input>
          <span class="box_btn" :class="{blue: state.send}" @click.stop.prevent="getCaptcha">
            {{ state.send ? state.title : state.time + 's' }}
          </span>
        </div>
        <a-button class="base_style" type="primary" @click="next2">下一步</a-button>
      </div>
      <!-- <a-form :form="verificationForm" class="verification">
        <p style="color: #5E668D; font-size: 16px; margin-bottom: 18px; margin-top: 40px;">
          验证码已发送至你的注册手机
        </p>
        <a-form-item>
          <div class="verify_box phone item_box">
            <a-input
              v-decorator="[
                'phone',
                {
                  rules: [{ required: true, message: '请输入手机号' }],
                  validateTrigger: ['blur', 'change'],
                  initialValue: handlePhone(telphone)
                }
              ]"
              :disabled="true"
            ></a-input>
            <a-button class="box_btn" @click="visible = false">修改</a-button>
          </div>
        </a-form-item>
        <a-form-item>
          <div class="verify_box phone item_box">
            <a-input
              placeholder="请输入验证码"
              :maxLength="6"
              v-decorator="[
                'code',
                { rules: [{ required: true, message: '请输入验证码' }], validateTrigger: 'blur' }
              ]"
            ></a-input>
            <button @click.stop.prevent="getCaptcha" class="box_btn send">
              {{ state.send ? state.title : state.time + 's' }}
            </button>
          </div>
        </a-form-item>
        <a-form-item>
          <a-button type="primary" @click="next2">下一步</a-button>
        </a-form-item>
      </a-form> -->
    </z-modal>
  </div>
</template>
<script>
import zModal from '@/components/ZModal'
import resetPass1 from './components/ResetPass1'
import resetPass2 from './components/ResetPass2'
import { featchCode, verifyCode, existMobile } from '@/api/system'
import { resset } from '@/api/user'
export default {
  name: '',
  data() {
    return {
      // verificationForm: this.$form.createForm(this, { name: 'verificationForm' }),
      visible: false,
      state: {
        time: 60,
        send: false,
        title: '重新发送'
      },
      // telphone: '',
      reset: false,
      is: resetPass1,
      title: '找回密码',
      loading: false,
      params: {
        telphone: '',
        code: ''
      }
    }
  },
  components: {
    zModal,
    resetPass1,
    resetPass2
  },
  watch: {
    visible(val) {
      if (val === false) {
        this.state.time = 60
        this.state.send = false
        this.timer && clearInterval(this.timer)
        return
      }
      this.openTimer()
    },
    reset(val) {
      this.is = val ? resetPass2 : resetPass1
      this.title = val ? '重置密码' : '找回密码'
    }
  },
  mounted() {},
  methods: {
    handlePhone(phone) {
      return phone.replace(/(?<=\d{3})\d{4}/, '****')
    },
    async next1(telphone) {
      try {
        if (this.loading) {
          return
        }
        this.loading = true
        this.telphone = telphone
        this.params.telphone = telphone
        const isExist = await existMobile({
          orgCode: this.$ls.get('code') || '',
          mobile: telphone
        })
        if (!isExist) {
          this.$message.error('你尚未注册账号')
          return
        }
        const res = await featchCode({ telphone })
        res && (this.visible = true)
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
      }
    },
    async next2() {
      if (!this.params.code.trim()) {
        this.$message.error('请输入验证码')
        return
      }
      const { code, telphone } = this.params
      this.code = code
      const res = await verifyCode({
        telphone,
        code
      })
      if (typeof res === 'boolean' && res === true) {
        this.visible = false
        this.reset = true
        this.loading = false
      } else {
        this.$message.error('验证码错误，请重新输入')
      }
      // this.verificationForm.validateFields(async (error, values) => {
      //   if (error || this.loading) {
      //     console.log('error', error)
      //     return
      //   }
      //   const { code } = values
      //   this.code = code
      //   const res = await verifyCode({
      //     telphone: this.telphone,
      //     code
      //   })
      //   if (res.data) {
      //     this.visible = false
      //     this.reset = true
      //     this.loading = false
      //   } else {
      //     this.$message.warning('请检查手机号或验证码是否正确')
      //   }
      // })
    },
    async confirm(ev) {
      console.log('ev', ev)
      try {
        if (this.loading) {
          return
        }
        const res = await resset({
          ...ev,
          ...this.params
          // telphone: this.telphone,
          // code: this.code
        })
        console.log(res)
        res &&
          this.$message.success('修改成功', 1, () => {
            this.$router.back()
          })
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
      }
    },
    openTimer() {
      clearInterval(this.timer)
      this.timer = setInterval(() => {
        if (this.state.time-- <= 0) {
          this.state.send = true
          this.state.time = 60
          clearInterval(this.timer)
        }
      }, 1000)
    },
    async getCaptcha() {
      if (!this.state.send) {
        return
      }
      const { telphone } = this.params
      const res = await featchCode({ telphone })
      if (res) {
        this.state.send = false
        this.openTimer()
      }
    }
  }
}
</script>
<style lang="less" scoped>
// @import './index.less';
// .back {
//   font-size: 16px;
//   color: #5e668d;
//   padding-top: 24px;
//   cursor: pointer;
// }
h3 {
    margin-bottom: 33px;
    font-size: 34px;
    line-height: 34px;
    font-weight: bold;
}
.base_style {
  height: 45px;
  line-height: 45px;
  border-radius: 23px;
  font-size: 16px;
}
.mb_24 {
  margin-bottom: 24px;
}
.retrieve_modal {
  padding: 18px;
  .verify_box {
    position: relative;
    display: flex;
    .ant-input {
      width: 335px;
    }
    .edit_btn {
      position: absolute;
      right: 0;
      width: auto;
      color: #1564ff;
      line-height: 45px;
      cursor: pointer;
    }
    .box_btn {
      position: absolute;
      right: 50px;
      width: auto;
      line-height: 45px;
      padding: 0 5px;
      color: #5e668d;
      cursor: pointer;
    }
    .blue {
      color: #1564FF;
    }
  }
  .ant-btn-primary {
    width: 100%;
    margin-top: 12px;
    background-color: #1564FF;
  }
}
// .verification {
//   .ant-input {
//     margin-right: 65px;
//   }
//   .item_box {
//     display: flex;
//     align-items: center;
//     justify-content: space-between;
//     position: relative;
//     .box_btn {
//       position: absolute;
//       right: 0;
//       width: auto;
//       line-height: 45px;
//       padding: 0;
//       background: none;
//       border: none;
//       color: #1564ff;
//     }
//     .send {
//       right: 81px;
//       cursor: pointer;
//     }
//   }
// }

// /deep/.ant-modal-content {
//   border-radius: 15px!important;
//   overflow: hidden!important;
// }
</style>
